module.exports = __webpack_public_path__ + "static/media/enabledCheckTicketIcon.fa0469e3.svg";